export default "__VITE_PUBLIC_ASSET__d1af363b__"